export const clamp = (value: number, min: number, max: number): number => Math.min(max, Math.max(min, value));

export const normalizeRatingAxisMax = (value: number): number => {
    if (!Number.isFinite(value) || value <= 0) {
        return 5;
    }

    return Math.max(5, Math.ceil(value * 2) / 2);
};

const toNiceNumber = (value: number, roundValue: boolean): number => {
    if (!Number.isFinite(value) || value <= 0) {
        return 1;
    }

    const exponent = Math.floor(Math.log10(value));
    const fraction = value / 10 ** exponent;
    let niceFraction = 1;

    if (roundValue) {
        if (fraction < 1.5) {
            niceFraction = 1;
        } else if (fraction < 3) {
            niceFraction = 2;
        } else if (fraction < 7) {
            niceFraction = 5;
        } else {
            niceFraction = 10;
        }
    } else if (fraction <= 1) {
        niceFraction = 1;
    } else if (fraction <= 2) {
        niceFraction = 2;
    } else if (fraction <= 5) {
        niceFraction = 5;
    } else {
        niceFraction = 10;
    }

    return niceFraction * 10 ** exponent;
};

export const buildNiceTickValues = (
    maxValue: number,
    approxTickCount = 4,
): {
    axisMax: number;
    tickValues: number[];
} => {
    const safeMaxValue = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 1;
    const safeTickCount = Number.isFinite(approxTickCount) && approxTickCount > 0 ? Math.floor(approxTickCount) : 4;
    const step = toNiceNumber(safeMaxValue / safeTickCount, true);
    const axisMax = Math.max(step, Math.ceil(safeMaxValue / step) * step);
    const tickValues = new Array(Math.max(1, Math.round(axisMax / step)) + 1)
        .fill(false)
        .map((_, index) => roundTo(index * step, 3));

    return {
        axisMax: roundTo(axisMax, 3),
        tickValues,
    };
};

export const roundTo = (value: number, fractionDigits = 2): number => {
    const scale = 10 ** fractionDigits;
    return Math.round(value * scale) / scale;
};

export const toRounded = (value: number): number => Number(value.toFixed(2));
